window.Currency = {
    rates: {
        USD: 1,
        EUR: 1.09598,
        GBP: 1.26944,
        CAD: 0.744461,
        AUD: 0.649994,
        INR: 0.0120583,
        PKR: 0.00347232
    },

    convert: function (amount, from, to) {
        from = from.toUpperCase();
        to = to.toUpperCase();

        if (
            !Object.prototype.hasOwnProperty.call(this.rates, from) ||
            !Object.prototype.hasOwnProperty.call(this.rates, to)
        ) {
            console.error("Currency rate not found:", from, to);
            return null;
        }

        return amount * this.rates[from] / this.rates[to];
    }
};